import { standardGetQuery } from "./apiUtils.js";
import { userOnPath } from "../shared/pageUtils.js";

import * as Constants from "../../config/constants/Constants.js";

/**
 * Fetch the status info about external resources.
 */
export const queryProgramStatus = (props) => {
    standardGetQuery(props, Constants.API_PROGRAM_STATUS, (response) => {
        props.backend.setProgramStatus(response.body);
    });
};

/**
 * Function for querying statistics about examinations.
 */
export const queryExaminationStatistics = (props, options = {}) => {
    standardGetQuery(
        props,
        Constants.API_STATISTICS_EXAMINATIONS,
        (response) => {
            props.backend.setExaminationStatistics(response.body);
        },
        {
            interval: 60,
            condition: () => userOnPath(["/home"])
        }
    );
};

/**
 * Function for querying statistics about patients.
 */
export const queryPatientStatistics = (props, options = {}) => {
    standardGetQuery(
        props,
        Constants.API_STATISTICS_PATIENTS,
        (response) => {
            props.backend.setPatientStatistics(response.body);
        },
        {
            interval: 60,
            condition: () => userOnPath(["/home"])
        }
    );
};
